import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import LegalLinks from '../components/LegalLinks';
import { useSeo } from '../hooks/useSeo';
import { LOGO_URL } from '../seoConfig';

const TEXT = {
  tr: {
    title: 'Sayfa bulunamadı | Powerlab Works',
    heading: 'Sayfa bulunamadı',
    body: 'Aradığınız sayfa taşınmış, kaldırılmış veya hiç var olmamış olabilir.',
    home: ['/tr/izmir-chip-tuning', 'Ana sayfaya dön'],
    calculator: 'Güç Hesaplayıcı',
  },
  en: {
    title: 'Page not found | Powerlab Works',
    heading: 'Page not found',
    body: 'The page you are looking for may have been moved, removed or never existed.',
    home: ['/', 'Back to home'],
    calculator: 'Power Calculator',
  },
};

const NotFound = () => {
  const { pathname } = useLocation();
  const lang = pathname.startsWith('/tr/') ? 'tr' : 'en';
  const t = TEXT[lang];
  useSeo({ title: t.title, description: t.body, lang });

  // The HTTP 404 comes from Caddy (build/404.html); this covers in-app navigation to an unknown path.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <div className="min-h-screen bg-black flex flex-col">
      <header className="border-b border-gray-800">
        <div className="container mx-auto px-4 py-4">
          <Link to={t.home[0]} className="inline-flex items-center">
            <img src={LOGO_URL} alt="Powerlab Works" className="h-14 w-auto object-contain" />
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center">
        <div className="container mx-auto px-4 py-24 text-center max-w-2xl">
          <p className="text-[#FF6600] font-bold text-7xl md:text-8xl mb-4">404</p>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">{t.heading}</h1>
          <p className="text-gray-400 text-lg mb-10">{t.body}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild className="bg-[#FF6600] hover:bg-[#E55A00] text-white px-8">
              <Link to={t.home[0]}>{t.home[1]}</Link>
            </Button>
            <Button asChild variant="outline" className="border-gray-700 bg-transparent text-gray-300 hover:text-white hover:bg-[#1a1a1a] px-8">
              <Link to="/calculator">{t.calculator}</Link>
            </Button>
          </div>
        </div>
      </main>

      <footer className="border-t border-gray-900 py-8 text-center">
        <LegalLinks lang={lang} />
      </footer>
    </div>
  );
};

export default NotFound;
